





import { defineComponent, useRoute, watch } from '@nuxtjs/composition-api'
import { useBackdropOverlay } from '~/composables/ui/useBackdropOverlay'

export default defineComponent({
  name: 'AppBackdropOverlay',

  setup() {
    const { visible, options, close } = useBackdropOverlay()

    const route = useRoute()
    watch(
      () => route.value.path,
      () => {
        close()
      }
    )

    return {
      visible,
      options,
    }
  },
})
